import { GetterTree } from 'vuex'
import { IAppState } from './types'

const getters: GetterTree<IAppState, any> = {
  appInfo (state: IAppState) {
    return state.appInfo || {}
  },

  appAuthConfigs (state: IAppState, getters) {
    return getters.appInfo.appAuthConfigs || undefined
  },

  appDeveloperList (state: IAppState, getters) {
    return getters.appInfo.admins || []
  },

  companyList (state: IAppState, getters) {
    return getters.appInfo.companyList || []
  },

  syncInfo (state: IAppState, getters) {
    return getters.appInfo.syncInfo || {}
  },

  companyId (state: IAppState, getters) {
    return getters.appInfo.companyId
  },

  authTabStatus (state: IAppState, getters) {
    return getters.appInfo.authTabStatus
  },

  syncTabStatus (state: IAppState, getters) {
    return getters.appInfo.syncTabStatus
  },

  msgCallbackTabStatus (state: IAppState, getters) {
    return getters.appInfo.msgCallbackTabStatus
  },

  callbackTabStatus (state: IAppState, getters) {
    return getters.appInfo.callbackTabStatus
  },

  docEditCbTabStatus (state: IAppState, getters) {
    return getters.appInfo.docEditCbTabStatus
  },

  docPreviewCbTabStatus (state: IAppState, getters) {
    return getters.appInfo.docPreviewCbTabStatus
  },

  docFormatCbTabStatus (state: IAppState, getters) {
    return getters.appInfo.docFormatCbTabStatus
  },

  spaceConfigTabStatus (state: IAppState, getters) {
    return getters.appInfo.spaceConfigTabStatus
  },

  applyFeatureList (state: IAppState, getters) {
    return getters.appInfo.applyFeatureList || []
  }
}

export default getters
